import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Sans lactose',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Épicé',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegan',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Sans gluten',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Végétarien',
};
